import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import { UrlService } from '../../services/url.service';
import { ApiClientService } from '../../services/api-client.service';
import { AuthenticationService } from '../../services/authentication.service';
import {DirectoryService} from '../../services/directory.service';

declare const toastr: any;

@Component({
    selector: 'vendors-filter',
    templateUrl: './vendors-filter.component.html',
    styleUrls: ['./vendors-filter.component.scss']
})
export class VendorsFilterComponent implements OnInit, OnDestroy {
    showDropdown = false;
    timeoutForFilterChanging = null;
    private urlServiceSubscription;
    private vendorsCategoriesSubscribtion;
    private dataRequestSubscribtion;
    constructor(
        private urlService: UrlService,
        public directoryService: DirectoryService,
        public api: ApiClientService,
        public authenticationService: AuthenticationService,
    ) { }

    ngOnInit() {
        this.urlServiceSubscription = this.urlService.onUrlChange.subscribe(_ => {
            this.directoryService.vendorsCategories.forEach(category => {
                if(!_.category) {
                    const checkboxes = (<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0]).childNodes;
                    for(let i = 0; i < checkboxes.length; i++) {
                        if(checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                            checkboxes[i].childNodes[1].childNodes[1].checked = false;
                        }
                    }
                }
            });
        });

        this.dataRequestSubscribtion = this.directoryService.onDataSend.subscribe(() => {
            if(this.directoryService.currentTabId != 'vendors')
                this.urlService.queryParams['category'] = null;
        });

        //Timeout for rendering checkboxes in filter
        this.vendorsCategoriesSubscribtion = this.directoryService.vendorsCategoriesReceived.subscribe(
            () => setTimeout(() => this.setCheckboxes(), 1000)
        );

        if(this.directoryService.vendorsCategories.length > 0)
            this.setCheckboxes();
    }

    changeFilter() {
        this.urlService.queryParams['category'] = [];
        const checkboxes = (<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0]).childNodes;
        for(let i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                if(checkboxes[i].childNodes[1].childNodes[1].checked) {
                    const categoryName = this.directoryService.vendorsCategories.find(vc => vc.id == checkboxes[i].childNodes[1].childNodes[1].id).name;
                    this.urlService.queryParams['category'].push(categoryName);
                }
            }
        }
        this.urlService.setQueryParams(null, 1);
    }

    timeOutBeforeFilterChanging(): void {
        if(this.timeoutForFilterChanging)
            clearTimeout(this.timeoutForFilterChanging);
        this.timeoutForFilterChanging = setTimeout(() => this.changeFilter(), 1000);
    }

    setCheckboxes() {
            const queryParams = this.urlService.getQueryParamsJson();

            if(!queryParams.category) {
                if((<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0])) {
                    const checkboxes = (<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0]).childNodes;
                    for (let i = 0; i < checkboxes.length; i++) {
                        if (checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                            checkboxes[i].childNodes[1].childNodes[1].checked = false;
                        }
                    }
                }
            } else {
                const selectedCheckboxesNames = typeof queryParams.category != 'string' ? queryParams.category.split(',') : [queryParams.category];
                const selectedCheckboxesIds = [];
                this.directoryService.vendorsCategories.forEach(c => {
                    if(selectedCheckboxesNames.indexOf(c.name) != -1)
                        selectedCheckboxesIds.push(c.id.toString());
                });

                this.directoryService.vendorsCategories.forEach(() => {
                    if((<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0])) {
                        const checkboxes = (<any>document.getElementsByClassName('vendors-filter-items-wrapper')[0]).childNodes;
                        for (let i = 0; i < checkboxes.length; i++) {
                            if (checkboxes[i].classList && checkboxes[i].classList.value.indexOf('filter-checkbox') != -1) {
                                if(selectedCheckboxesIds.indexOf(checkboxes[i].childNodes[1].childNodes[1].id) != -1)
                                    checkboxes[i].childNodes[1].childNodes[1].checked = true;
                            }
                        }
                    }
                });
            }
    }

    ngOnDestroy() {
        this.urlServiceSubscription.unsubscribe();
        this.dataRequestSubscribtion.unsubscribe();
        this.vendorsCategoriesSubscribtion.unsubscribe();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('vendors-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/vendors-filter/vendors-filter.component.ts